import React from "react";
import { context } from './AppContext';
import Locale from '../locale/Locale';
import TopBar from './TopBar';
import { default as Screens } from './screens';
import { ReactComponent as RobotRelaxing } from '../assets/robot/svg/relaxing_cocktail.svg';
import { ReactComponent as RobotWarning } from '../assets/robot/svg/report_warning.svg';


export default class Main extends React.Component {
    state = { 
        current: "users"
    }

    componentDidMount() {
        context.on("navigate", () => {
            this.setState({});            
        });
    }

    render() {
        const match = context.matchPath("/:page");
        let page = match ? "/" + match.params.page : "";
        // Allow switching away from Dev and Local
        if (!context.userInfo && ![ "Local", "Dev" ].includes(window.localStorage.realm)) {
            return <div><h1>{ Locale.gettext("Loading...") }</h1></div>;
        }
        return (
            <div>
                <TopBar 
                    activeKey={ page } 
                    onSelect={ (newKey) => this.setState({ current: newKey}) }
                />
                <div id="page-content-wrapper">
                    { this.renderSwitch(page) }
                </div>
            </div>
         );
    }

    renderSwitch(page) {
        if (context.userInfo?.organizations.length === 0) {
            return (
                <div style={{ width: '100%', height: '100%', textAlign: 'center' }}>
                    <RobotWarning width="300"/>
                    <h2>{ Locale.gettext("This site is only available for dealers.") }</h2>
                    <h4>{ Locale.gettext("Please reach out to Poolside Support for assistance.") }</h4>
                    <br/>
                    <h3 style={{ cursor: 'pointer' }} onClick={ () => {
                        context.logout();
                    }}>{ Locale.gettext("Logout") }</h3>
                </div>
            );
        }
        switch (page)  {
            case '/alerts':
                return <Screens.Alerts key="alerts" />;
            case "/attendant_sizing_tool":
                return <Screens.Configurator />;
            case '/sites':
            case '/':
                return <Screens.Sites key="sites"/>;
            default:
                return (
                    <div style={{ width: '100%', height: '100%', textAlign: 'center' }}>
                        <RobotRelaxing width="300"/>
                        <h2>{ Locale.gettext("Please select a menu item to begin.") }</h2>
                    </div>
                );
        }
    }
}